import { CARD_TYPES } from 'cards/components/CardListing/types';

export const FILTER_TYPE_ALL = 'all';

export const CARD_TYPE_DATA = {
  [FILTER_TYPE_ALL]: { name: 'Invites & Paper', url: '/wedding-planning/save-the-date/shop' },
  [CARD_TYPES.std]: { name: 'Save the Dates', url: '/wedding-planning/save-the-date/shop' },
  DIGITAL_SAVE_THE_DATE: {
    name: 'Digital Save the Dates',
    url: '/wedding-planning/digital/save-the-date/shop',
  },
  [CARD_TYPES.invitation]: { name: 'Invitations', url: '/wedding-planning/invitations/shop' },
  [CARD_TYPES.ctd]: { name: 'Change the Dates', url: '/wedding-planning/change-the-date/shop' },
  [CARD_TYPES.enclosure]: { name: 'Enclosure Cards', url: '/wedding-planning/enclosures/shop' },
  [CARD_TYPES.menu]: { name: 'Menus', url: '/wedding-planning/menus/shop' },
  [CARD_TYPES.program]: { name: 'Programs', url: '/wedding-planning/programs/shop' },
  [CARD_TYPES.holiday]: { name: 'Holiday Cards', url: '/wedding-planning/holiday-cards/shop' },
  [CARD_TYPES.thankyou]: {
    name: 'Thanks You Cards',
    url: '/wedding-planning/thank-you-cards/shop',
  },
  [CARD_TYPES.place]: { name: 'Place Cards', url: '/wedding-planning/place-cards/shop' },
};

export const SAVED_PHOTOS_KEY = 'inspiration';
export const SAVED_VENDORS_KEY = 'vendors';
export const PAPER_KEY = 'paper';
export const VENUE_IDEAS_KEY = 'venue-ideas';
export const FLOWERS_KEY = 'flowers';
export const GETTING_READY_IDEAS_KEY = 'getting-ready-ideas';
export const DESSERTS_KEY = 'desserts';

export type COLLECTION_KEYS =
  | typeof SAVED_PHOTOS_KEY
  | typeof SAVED_VENDORS_KEY
  | typeof PAPER_KEY
  | typeof VENUE_IDEAS_KEY
  | typeof FLOWERS_KEY
  | typeof GETTING_READY_IDEAS_KEY
  | typeof DESSERTS_KEY;

export const COLLECTION_KEYS_LIST: COLLECTION_KEYS[] = [
  SAVED_PHOTOS_KEY,
  SAVED_VENDORS_KEY,
  VENUE_IDEAS_KEY,
  FLOWERS_KEY,
  // GETTING_READY_IDEAS_KEY, // INSPO-5512
  DESSERTS_KEY,
  PAPER_KEY,
];
